<template>
  <v-card title="年假查询">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input size="mini" v-model="cx_ssnd" placeholder="所属年度" valueFormat="yyyy" type="year"></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <vxe-select v-model="khbh" size="mini" placeholder="请选择客户" :options="khbh_options" clearable @change="xz_khbh"></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-tree-select
                  @check="onCheck"
                  @clear="onClear"
                  style="padding-top: 2px; width: 200px"
                  :data="treeData2"
                  placeholder="请选择地区"
                  allow-clear
                  multiple
                ></v-tree-select>
              </v-form-item>
              <v-form-item>
                <vxe-select
                  v-model="fz"
                  size="mini"
                  placeholder="请选择组别"
                  :options="fz_options"
                  clearable
                ></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-table
     :showOverflow="true"
      size="mini"
      border
      height="408"
      :data="tableData"
      :expand-config="{
        accordion: true,
        lazy: true,
        loadMethod: loadContentMethod,
      }"
    >
      <vxe-table-column type="seq" width="60" title="序号" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column type="expand" width="80" header-align="center" align="center">
        <template v-slot:content="{ row }">
          <vxe-grid class="mytable-style" :columns="row.childCols" :data="row.childData"></vxe-grid>
        </template>
      </vxe-table-column>
      <vxe-table-column field="gh" title="工号" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column field="xm" title="姓名" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column field="khbh" title="客户编号" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column field="khmc" title="客户名称" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column field="rzrq" title="入职日期" header-align="center" align="center"></vxe-table-column>
      <vxe-table-column field="snsynj" title="上年剩余年假" header-align="center" align="right"></vxe-table-column>
      <vxe-table-column field="dnkynj" title="当年可用年假" header-align="center" align="right"></vxe-table-column>
      <vxe-table-column field="dnznj" title="当年总年假" header-align="center" align="right"></vxe-table-column>
      <vxe-table-column
        field="dnysynj"
        title="当年已使用年假"
        header-align="center" align="right"
      ></vxe-table-column>
      <vxe-table-column field="dnsynj" title="当年剩余年假" header-align="center" align="right"></vxe-table-column>
    </vxe-table>
  </v-card>
</template>
<script>
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      treeData2: [],
      khbh_options: [],
      fz_options:[],
      khbh:"",
      dq: [],
      fz:"",
      cx: "",
      cx_ssnd:new Date().getFullYear().toString(),
      rse_nd:""
    };
  },
  created() {
    this.init_khbh();
    this.findList();
  },
  methods: {
    findList() {
      if(this.cx_ssnd == ""){
        this.$message["error"]("请选择所属年度！");
        return;
      }
      this.$axios.get("api/system/njcx/get-njcx-list?cx=" + this.cx+"&ssnd="+this.cx_ssnd+"&khbh="+this.khbh+
            "&dq=" +
            this.dq+
            "&fz="+this.fz).then((res) => {
        this.tableData = res.data.data;
        this.rse_nd = res.data.nd;
      });
    },
    init_khbh: function () {
      this.$axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khjc };
        });
      });
    },
    xz_khbh: function () {
      this.init_dq();
    },
    init_dq: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-dq?khbh=" + this.khbh)
        .then((res) => {
          let self = this;
          if (res.data.code == 200) {
            let self = this;
            self.treeData2 = res.data.data;
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    init_fz: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-fz?khbh=" + this.khbh + "&khdq=" + this.dq)
        .then((res) => {
          let self = this;
          self.fz_options = res.data.data.map((item) => {debugger;
            return { value: item.fzmc, label: item.fzmc };
          });
        });
    },
    exportExcel() {
      if(this.cx_ssnd == ""){
        this.$message["error"]("请选择所属年度！");
        return;
      }
      let a = document.createElement("a");
      a.href = "api/system/njcx/年假统计?cx=" + this.cx+"&ssnd="+this.cx_ssnd+"&khbh="+this.khbh+
            "&dq=" +
            this.dq+
            "&fz="+this.fz;
      a.click();
    },
    onCheck(data) {
      this.dq = [];
      for (var i = 0; i < data.length; i++) {
        this.dq.push(data[i].id);
      }
      // this.dq = [];
      // for (var i = 0; i < data.length; i++) {
      //   if (data[i].children) {
      //     for (var j = 0; j < data[i].children.length; j++) {
      //       this.dq.push(data[i].children[j].id);
      //     }
      //   }
      // }
      this.init_fz();
      console.log(this.dq);
    },
    onClear(data) {
      this.dq = [];
      this.fz = "";
      console.log("clear", this.dq);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    loadContentMethod({ row }) {
      return new Promise((resolve) => {
        const childCols = [
          { type: "seq", title: "序号" ,align: "center"},
          { field: "xm", title: "姓名" ,align: "center"},
          { field: "khmc", title: "客户名称" ,align: "center"},
          { field: "xjrq", title: "休假日期" ,align: "center"},
          { field: "xjz", title: "休假时长(小时)" ,align: "right" ,headerAlign:"center"},
        ];
        row.childCols = childCols;
        this.$axios
          .get("api/system/njcx/get-njcx-listmx?gh=" + row.gh+"&nd="+this.rse_nd)
          .then((res) => {
            row.childData = res.data.data;
            resolve();
          });
        
      });
    },
    headerCellClassName ({ column, columnIndex }) {
              if (column.property === 'xm') {
                return 'col-blue'
              }
            },
  },
};
</script>


<style>
.mytable-style .vxe-table .vxe-table--header{
  background-color: rgb(170, 168, 168);
  color: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/view/kqgl/njcx.vue